<script setup lang="ts">
import Promotion618ModalShell from "./Promotion618ModalShell.vue";
import {
  PROMOTION_618_ACTIVE_MEMBER_COUNTDOWN_TOP,
  PROMOTION_618_MODAL_IMAGES
} from "./constants";

const modalId = "promotion-618-active-member-modal";
defineOptions({ modalId });

interface Props {
  onClose?: () => void;
}

defineProps<Props>();
</script>

<template>
  <Promotion618ModalShell
    :modal-id="modalId"
    :image-url="PROMOTION_618_MODAL_IMAGES.activeVipSvip!"
    popup-name="active_member"
    :countdown-top="PROMOTION_618_ACTIVE_MEMBER_COUNTDOWN_TOP"
    :on-close="onClose"
  />
</template>
